import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20carefully%20arranged%20fashion%20items%20on%20warm%20terracotta%20gradient%20surface%20viewed%20from%20above%2C%20soft%20linen%20fabric%20draped%20elegantly%2C%20a%20leather%20journal%20and%20reading%20glasses%20nearby%2C%20warm%20golden%20afternoon%20sunlight%20creating%20long%20gentle%20shadows%2C%20minimalist%20sophisticated%20European%20aesthetic%2C%20editorial%20quality%2C%20no%20text%2C%20airy%20spacious%20feel%20with%20organic%20textures%20and%20muted%20earth%20tones&width=1920&height=1080&seq=hero-bg-v3&orientation=landscape"
          alt="PandabuySpreadsheet product comparison background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-8 py-16 md:py-20">
        <div className="max-w-4xl mx-auto">
          <p className="text-sm md:text-base font-medium text-white/80 tracking-widest uppercase mb-4">
            Structured Product Intelligence
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            Smart Product
            <br />
            Comparison
            <br />
            <span className="text-primary-300">Starts Here</span>
          </h1>
          <p className="text-base md:text-lg text-white/70 max-w-2xl mx-auto mb-8 leading-relaxed">
            Find, compare, and analyze product data using structured spreadsheet insights.
            Save time, reduce costs, and make smarter buying decisions with data-driven product breakdowns.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Spreadsheets
              <i className="ri-arrow-right-up-line text-lg"></i>
            </a>
            <Link
              to="/blog/pandabuy-spreadsheet-comparison-guide"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-white/30 text-white font-semibold text-base hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
            >
              Read Our Guide
              <i className="ri-arrow-right-line text-lg"></i>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/50">
        <span className="text-xs tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-s-line text-lg animate-bounce"></i>
      </div>
    </section>
  );
}